import HomeRoute from './Home'
import EditorRoute from './Editor'
import ListRoute from './List'
import MaterialRoute from './Material'

export default [
  HomeRoute,
  EditorRoute,
  ListRoute,
  MaterialRoute
]
